module.exports = __webpack_public_path__ + "static/media/MVNZ_web_6.c0775aba.jpg";